import { useMutation, UseMutationOptions } from 'react-query';

import { authApi } from 'src/Services/API';
import { RegisterUserDto, UserWithPrivateInfoDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';
import { trackUserSignedUp } from 'src/Services/Mixpanel/events';

const getCookie = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match?.[2] ?? undefined;
};

export const useRegister = (
  options?: UseMutationOptions<UserWithPrivateInfoDto, unknown, RegisterUserDto>
) => {
  return useMutation<UserWithPrivateInfoDto, unknown, RegisterUserDto>(
    'register',
    async data => {
      const response = await authApi.authControllerCreate({
        ...data,
        fbc: getCookie('_fbc'),
        fbp: getCookie('_fbp'),
      });
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Auth', 'register', data.email);
        trackUserSignedUp({ method: 'email_password' });
        (
          window as {
            fbq?: (track: string, event: string, params: object, options: object) => void;
          }
        ).fbq?.('track', 'CompleteRegistration', {}, { eventID: `registration_${data.id}` });
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
